import useMobile from '../../../hooks/useMobile';
import './input.scss';

interface InputInterface {
  label?: string;
  name: string;
  id?: any;
  type?: any;
  placeholder?: string;
  register: any;
  validationRules?: any;
  error?: any;
  maxLength?: any;
  setValue?: any;
  onChange?: any;
  onBlurEvent?: any;
  onFocusEvent?: any;
  square?: boolean;
  required?: boolean;
  tooltip?: any;
  onTypeValidation?: boolean;
  disabled?: boolean;
  role?: string;
}

const Input = ({
  label,
  name,
  id,
  type,
  placeholder,
  register,
  validationRules,
  error,
  maxLength,
  setValue,
  onChange,
  onBlurEvent,
  onFocusEvent,
  square,
  required,
  tooltip,
  onTypeValidation,
  disabled,
  role,
}: InputInterface) => {
  // Que le debe llegar a este componente?
  // --label: que sera el nombre arriba del campo mostrado si llega
  // --name: nombre com el que se identificara el input
  // --type: el tipo de input que es
  // --placeholder: este es autodescriptivo
  // --register: que viene del react hook form y lo enlaza el dato ingresado al formulario
  // --validationRules: estas son las validaciones que debe tener el input, justo con su mensaje de error
  // deben ser enviadas como un JSON
  // --error: aqui debe enviarse el error correspondiente al input y que contiene el mensaje de error
  // square: si su valor es true el estilo del input cambia a uno encerrado por un borde
  // required: dice si es requerido y activa
  // tooltip: recibe un componente y este será el tooltip que se muestre

  const mobile = useMobile();

  return (
    <div className="f-a-input">
      <div className={`f-a-input__label-wrapper ${square ? ' __square' : ''}`}>
        <label
          id={name + label}
          htmlFor={name}
          className={`f-a-input__label ${required ? ' __required' : ''}`}
        >
          {label}
        </label>
        {tooltip && (
          <div className="f-a-input__tooltip">
            <i
              data-testid="icon"
              className="icon icon-question-circle"
              onClick={() => {
                if (mobile) {
                  const getTooltip = document.getElementById('f-a-input__tooltip-box-wrapper');
                  getTooltip && getTooltip.classList.add('__open');
                }
              }}
            />
            <div
              className="f-a-input__tooltip-box-wrapper"
              id="f-a-input__tooltip-box-wrapper"
              onClick={() => {
                if (mobile) {
                  const getTooltip = document.getElementById('f-a-input__tooltip-box-wrapper');
                  getTooltip && getTooltip.classList.remove('__open');
                }
              }}
            >
              <div className="f-a-input__tooltip-box">{tooltip}</div>
            </div>
          </div>
        )}
      </div>
      <div
        id={name}
        className={`f-a-input__box ${error ? '__error' : ''}${square ? ' __square' : ''}`}
      >
        {!onTypeValidation ? (
          <input
            data-testid="input"
            tabIndex="0"
            name={name}
            maxLength={maxLength}
            placeholder={placeholder}
            type={type}
            {...register(name, validationRules)}
            onChange={(e) => {
              if (e.target.value === ' ') {
                setValue(name, '');
              } else {
                onChange(e);
                if (type === 'number') {
                  const newValue = e.target.value.replace(/\D/g, '');
                  setValue(name, newValue);
                } else {
                  setValue(name, e.target.value.replace(/ {2}/g, ' '));
                }
              }
            }}
            onFocus={() => {
              onFocusEvent && onFocusEvent();
            }}
            onBlur={() => {
              onBlurEvent && onBlurEvent();
            }}
            id={id || `input${name}`}
            disabled={disabled || false}
            role={role}
          />
        ) : (
          <input
            data-testid="input"
            tabIndex="0"
            name={name}
            maxLength={maxLength}
            // max={type === "number" && maxLength}
            placeholder={placeholder}
            type={type}
            {...register(name, validationRules)}
            onFocus={() => {
              onFocusEvent && onFocusEvent();
            }}
            onBlur={() => {
              onBlurEvent && onBlurEvent();
            }}
            id={id || `input${name}`}
            disabled={disabled || false}
            role={role}
          />
        )}
      </div>
      {error && <span className="f-a-input__error">{error.message}</span>}
    </div>
  );
};

// Especifica los valores por defecto de props:
Input.defaultProps = {
  onChange: () => {},
};

export default Input;
